import { z } from "zod";

export const NpmRegistryAuthType = z.enum(["Basic", "Bearer", "None", "Custom"]);
export const NpmRegistryType = z.enum(["NPMJS", "GitHub", "AzureDevOps", "Artifactory", "Custom"]);

export const NpmRegistryBasicAuthConfig = z.object({
  authType: z.literal(NpmRegistryAuthType.Enum.Basic),
  username: z.string(),
  password: z.string(),
});

export const NpmRegistryBearerAuthConfig = z.object({
  authType: z.literal(NpmRegistryAuthType.Enum.Bearer),
  accessToken: z.string(),
});

export const NpmRegistryNoAuthConfig = z.object({
  authType: z.literal(NpmRegistryAuthType.Enum.None),
});

export const NpmRegistrCustomAuthConfig = z.object({
  authType: z.literal(NpmRegistryAuthType.Enum.Custom),
  authHeaderName: z.string(),
  authHeaderValue: z.string(),
});

export const NpmRegistryAuthConfig = z.discriminatedUnion("authType", [
  NpmRegistryBasicAuthConfig,
  NpmRegistryBearerAuthConfig,
  NpmRegistryNoAuthConfig,
  NpmRegistrCustomAuthConfig,
]);

const NpmRegistryConfigBase = z.object({
  registryType: NpmRegistryType,
  enabledScopes: z.array(z.string()),
  customRegistryUrl: z.string().optional(),
  bypassProxy: z.boolean().default(false),
  npmProxyRegistryConfigId: z.string().optional(),
  npmProxyVersion: z.number().optional(),
});

export const NpmRegistryConfig = NpmRegistryConfigBase.and(NpmRegistryAuthConfig);

export type NpmRegistryConfig = z.infer<typeof NpmRegistryConfig>;
